var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "#16181E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9985 11L21.9979 12.278L26.9985 13.9459L30.631 12.7351L31.2634 14.6325L28.2319 15.643L31.3272 24.1549C30.2353 25.2921 28.6996 26 26.9985 26C25.2975 26 23.7618 25.2921 22.6699 24.1549L25.7639 15.643L21.9979 14.387V28H25.9985V30H15.9985V28H19.9979V14.387L16.2319 15.643L19.3272 24.1549C18.2353 25.2921 16.6996 26 14.9985 26C13.2975 26 11.7618 25.2921 10.6699 24.1549L13.7639 15.643L10.7336 14.6325L11.3661 12.7351L14.9985 13.9459L19.9979 12.278L19.9985 11H21.9985ZM26.9985 18.1027L25.04 23.4892C25.628 23.8201 26.2979 24 26.9985 24C27.6992 24 28.3691 23.8201 28.957 23.4892L26.9985 18.1027ZM14.9985 18.1027L13.04 23.4892C13.628 23.8201 14.2979 24 14.9985 24C15.6992 24 16.3691 23.8201 16.957 23.4892L14.9985 18.1027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.80ba8e51d7f058d1431d0e5437cf13a1.svg";
export { ForwardRef as ReactComponent };